import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    borderRadius: 5,
    marginBottom: 20,
  },
  tableContainer: {
    height: 300,
    overflow: 'auto',
  },
  tableHead: {
    fontWeight: 'bold',
  },
  tableCell: {
    padding: '5px 20px',
  },
  tableRow: {
    cursor: 'pointer',
  },
  activeRow: {
    '& td': {
      backgroundColor: '#adffb8',
    },
  },
}));
